<template >
     <bernstein-layout>
         <!-- {{purchases}} -->
    <div class="py-2 flex flex-row justify-between "> 
      <Link  v-if="purchases.prev_page_url" class="m-2 px-2 py-2 bg-gray-300 rounded" :href="purchases.prev_page_url" >Previous Page </Link> 
      <Link  v-if="purchases.next_page_url" class="m-2 px-2 py-2 bg-gray-300 rounded" :href="purchases.next_page_url">Next Page </Link> 
      </div>
       <!-- Here starts the table  -->
           <!-- {{variations.next_page_url}} -->
    <div class=" flex flex-col  overscroll-x-contain ">
      <!-- <div class="flex-grow overflow-auto"> -->
        <Table
        :filters="queryBuilderProps.filters"
        :search="queryBuilderProps.search"
        :columns="queryBuilderProps.columns"
        :on-update="setQueryBuilder"
        :meta="purchases"  
        class="relative w-full border"
        >
          <!-- header  -->
       <template #head >        
            <tr class="py-2 border-b border-gray-400 bg-gray-300 text-gray-900 font-bold sticky ">
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('barbeiten')" >Bearbeiten</th>
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('orderId')" @click.prevent="sortBy('orderId')">Order Id</th>
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('manufacturer')" @click.prevent="sortBy('manufacturer')">Manufacturer</th>
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('billNo')" @click.prevent="sortBy('billNo')">Rechnungsnummer</th>
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('anzahlung_betrag_usd')" @click.prevent="sortBy('anzahlung_betrag_usd')">AZ Betrag (USD)</th>
                <!-- anzahlung_kurs -->
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('anzahlung_kurs')" @click.prevent="sortBy('anzahlung_kurs')">AZ Kurs </th>
                <!-- anzahlung_rechnung -->
                <th class="sticky top-0 border-r border-green-200"  v-show="showColumn('anzahlung_rechnung')">Anzahlung Rechnung</th>      
        
                <!-- anzahlung_datum -->
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('anzahlung_datum')" @click.prevent="sortBy('anzahlung_datum')">AZ Datum </th>
                <!-- az_notiz -->
                 <th class="sticky top-0 border-r border-green-200" v-show="showColumn('az_notiz')">AZ Notiz </th>
                <!-- rz_betrag_usd -->
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_betrag_usd')" @click.prevent="sortBy('rz_betrag_usd')">Rz Betrag (USD)</th>
                <!-- rz_kurs -->
                 <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_kurs')" @click.prevent="sortBy('rz_kurs')">RZ Kurs </th>
               <!-- rz_rechnung -->
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_rechnung')" >RZ Rechnung </th>
                <!-- rz_datum -->
                  <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_datum')" @click.prevent="sortBy('rz_datum')">RZ Datum </th>
              <!-- rz_notiz -->
                   <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_notiz')" >RZ Notiz </th>
                <!-- verrechnung -->
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('verrechnung')" >Verrechnung </th>
                <!-- oz_usd -->
                <th class="sticky top-0 border-r border-green-200" v-show="showColumn('oz_usd')" @click.prevent="sortBy('oz_usd')" >OffneZahlung (USD)</th>
                <!-- container_preis -->
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('container_preis')" @click.prevent="sortBy('container_preis')"  >Container Preise </th>
              <!-- waren_eingang_id -->
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('waren_eingang_id')" @click.prevent="sortBy('waren_eingang_id')"  >Wareneingang Id</th>
                <!-- waren_eingang_datum -->
              <th class="sticky top-0 border-r border-green-200" v-show="showColumn('waren_eingang_datum')" @click.prevent="sortBy('waren_eingang_datum')"  >Wareneingang Datum</th>
              <!-- kreditor               -->
               <th class="sticky top-0 border-r border-green-200" v-show="showColumn('kreditor')" @click.prevent="sortBy('kreditor')"  >Kreditor </th>
            <!-- kreditor_nummer -->
            <th class="sticky top-0 border-r border-green-200" v-show="showColumn('kreditor_nummer')" @click.prevent="sortBy('kreditor_nummer')"  >Kreditornummer </th>
            <!-- az_euro -->
            <th class="sticky top-0 border-r border-green-200" v-show="showColumn('az_euro')" @click.prevent="sortBy('az_euro')"  > Anzahlung (Euro)</th>
            <!-- rz_euro  -->
            <th class="sticky top-0 border-r border-green-200" v-show="showColumn('rz_euro')" @click.prevent="sortBy('rz_euro')"  > Restzahlung (Euro)</th>
           <!-- created_at -->
            <th class="sticky top-0 border-r border-green-200" v-show="showColumn('created_at')" @click.prevent="sortBy('created_at')"  >Eingetragen am</th>
         </tr>
            <!-- <tr><th class="fixed top-0"> test</th> </tr>      -->
        </template> 
         <!-- here  starts the body of the table  -->
        <template #body>
            <tr v-for="(purchase, purchaseIndx) in purchases.data" :key="purchaseIndx"
                :class="[{'bg-gray-100':purchaseIndx%2==0}, p-1]" 
            >
               <!-- Bearbeiten  -->
                <td class="border-r border-green-200" v-show="showColumn('barbeiten')">
                    <div  class="flex flex-row space-x-3 items-center"> 
                    <a :href="'/purchases/'+purchase.id+'/edit'" class="max-h-8">
                        <svg height="40" viewBox="0 0 48 48" width="40" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 34.5v7.5h7.5l22.13-22.13-7.5-7.5-22.13 22.13zm35.41-20.41c.78-.78.78-2.05 0-2.83l-4.67-4.67c-.78-.78-2.05-.78-2.83 0l-3.66 3.66 7.5 7.5 3.66-3.66z"/><path d="M0 0h48v48h-48z" fill="none"/>
                        </svg>
                    </a>  
                      <button v-if="!purchase.deleted_at" 
                       class="text-red-600 hover:underline" tabindex="-1" type="button" 
                       @click="destroy(purchase)"> 
                      <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  
                        viewBox="0 0 30 30" width="30px" height="30px">   
                        <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031111 24.234375 L 24 9 L 6 9 z"/>
                      </svg>
                      </button>
                    </div> 
                </td>
               
                <td class="border-r border-green-200" v-show="showColumn('orderId')">{{ purchase.orderId}}</td>
                <td class="border-r border-green-200" v-show="showColumn('manufacturer')">{{purchase.manufacturer}}</td>
                <td class="border-r border-green-200" v-show="showColumn('billNo')">{{ purchase.billNo}}</td>
                <td class="border-r border-green-200" v-show="showColumn('anzahlung_betrag_usd')">{{ purchase.anzahlung_betrag_usd}}</td>
                <!-- anzahlung_kurs -->
                <td class="border-r border-green-200" v-show="showColumn('anzahlung_kurs')">{{ purchase.anzahlung_kurs}}</td>
                <!-- anzahlung_rechnung -->
                  <td class="border-r border-green-200" v-show="showColumn('anzahlung_rechnung')"> 
                    <a v-if ="purchase.anzahlung_rechnung" 
                        :href="getUrl()+purchase.anzahlung_rechnung" >AZ Rechnung </a> 
                </td>
                <!-- anzahlung_datum -->
                <td class="border-r border-green-200" v-show="showColumn('anzahlung_datum')">{{ purchase.anzahlung_datum}}</td>
                <!-- az_notiz -->
               <td class="border-r border-green-200" v-show="showColumn('az_notiz')">{{ purchase.az_notiz}}</td>
               <!-- rz_betrag_usd -->
              <td class="border-r border-green-200" v-show="showColumn('rz_betrag_usd')">{{ purchase.rz_betrag_usd}}</td>
              <!-- rz_kurs -->
                <td class="border-r border-green-200" v-show="showColumn('rz_kurs')">{{ purchase.rz_kurs}}</td>
                <!-- rz_rechnung -->
                <td class="border-r border-green-200" v-show="showColumn('anzahlung_rechnung')"> 
                    <a v-if ="purchase.rz_rechnung" 
                        :href="getUrl()+purchase.rz_rechnung" >RZ Rechnung </a> 
                </td>
                <!-- rz_datum -->
                <td class="border-r border-green-200" v-show="showColumn('rz_datum')">{{ purchase.rz_datum}}</td>
                <!-- rz_notiz -->
                <td class="border-r border-green-200" v-show="showColumn('rz_notiz')">{{ purchase.rz_notiz}}</td>

                <!-- verrechnung -->
                <td class="border-r border-green-200" v-show="showColumn('verrechnung')">{{ purchase.verrechnung}}</td>
                <!-- oz_usd -->
            <td class="border-r border-green-200" v-show="showColumn('oz_usd')">{{ purchase.oz_usd}}</td>
                <!-- container_preis -->
              <td class="border-r border-green-200" v-show="showColumn('container_preis')">{{ purchase.container_preis}}</td>
             <!-- waren_eingang_id -->
             <td class="border-r border-green-200" v-show="showColumn('waren_eingang_id')">{{ purchase.waren_eingang_id}}</td>
              <!-- waren_eingang_datum -->
               <td class="border-r border-green-200" v-show="showColumn('waren_eingang_datum')">{{ purchase.waren_eingang_datum}}</td>
              <!-- kreditor -->
            <td class="border-r border-green-200" v-show="showColumn('kreditor')">{{ purchase.kreditor}}</td>
            <!-- kreditor_nummer -->
            <td class="border-r border-green-200" v-show="showColumn('kreditor_nummer')">{{ purchase.kreditor_nummer}}</td>
            <!-- az_euro -->
            <td class="border-r border-green-200" v-show="showColumn('az_euro')">{{ purchase.az_euro}}</td>
           
           <!-- rz_euro -->
           <td class="border-r border-green-200" v-show="showColumn('rz_euro')">{{ purchase.rz_euro}}</td>
           <!-- created_at -->
           <td class="border-r border-green-200" v-show="showColumn('created_at')">{{ purchase.created_at}}</td>
           
            </tr>
    </template>

         <!-- end of table  -->
        </Table>
    </div>

    </bernstein-layout> 
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'
import { InteractsWithQueryBuilder, Tailwind2 } from '@protonemedia/inertiajs-tables-laravel-query-builder';
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
  DialogTitle,
} from '@headlessui/vue'
import { ref } from 'vue'
// import Button from '../../Jetstream/Button.vue';
export default {
   mixins: [InteractsWithQueryBuilder],
  components: {  
   BernsteinLayout, 
   Head, 
   Link, 
   Table: Tailwind2.Table,
// Modal components 
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle
    // Button,
   },
    props:{
     purchases: Array
  },
    methods:{
          getUrl() {
            return "/storage/";
        },
        getEditRef(id){
           return  "/purchases/"+ id +"/edit"
        },
        destroy(purchase) {
         if (confirm('Bist Du Sicher dass Du diese Eintrag löschen möchtest?')) {
            this.$inertia.delete(`/purchases/${purchase.id}`)
         }
        }
    }//end of methods 
}
</script>